// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3P_8p","productName":"Table_productName__2R_Pw"};